export default __webpack_public_path__ + "static/media/logo-admin-light.145d3150.png";